import classNames from 'classnames';
import i18next from 'i18next';
import { useEffect } from 'react';
import { SwiperSlide } from 'swiper/react';
import { breakpoints } from '~/components/Breakpoint/Breakpoint.hook';
import { Carousel, CarouselProps } from '~/components/Carousel';
import { useHomeBanners } from '~/components/Home/Hero/HomeHero.hooks';
import { HomeHeroItem } from '~/components/Home/Hero/Item/HomeHeroItem';
import styles from './HomeHero.module.scss';

const carouselProps: CarouselProps = {
  autoplay: { delay: 4000, disableOnInteraction: false },
  pagination: true,
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    [breakpoints.large]: {
      slidesPerView: 1,
      spaceBetween: 100,
    },
  },
  shadow: true,
};

export type HomeHeroProps = {
  className?: string;
};

export const HomeHero = ({ className }: HomeHeroProps) => {
  const { data: bannerList = [], refetch } = useHomeBanners();

  useEffect(() => {
    const handleLanguageChanged = () => {
      refetch();
    };
    i18next.on('languageChanged', handleLanguageChanged);

    return () => {
      i18next.off('languageChanged', handleLanguageChanged);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Carousel
      className={classNames(styles.root, className)}
      {...carouselProps}
      loop={bannerList.length > 1}
      loopAdditionalSlides={bannerList.length}>
      {bannerList.map((banner) => (
        <SwiperSlide key={banner.id}>
          <HomeHeroItem {...banner} />
        </SwiperSlide>
      ))}
    </Carousel>
  );
};
